import { RegistrationCitizenshipFormVM } from 'mutation/view-models/registration-citizenship';
import { DatiAggiuntiviSide, ModelEventoDTO } from 'shell/models/act-category-list';
import { transformerEditDataControl } from './transformer-edit-data-control';
import { transformerNewCitizenship } from './transformer-new-citizenship';
import { ItemVM } from 'shell/view-models/item';
import { MotArtCitizenship } from 'shell/models/mutation/mot-art-citizenship';

export const transformerCitizenshipFromModel = (
  modelEventoDTO?: ModelEventoDTO,
  datiAggiuntiviSide?: DatiAggiuntiviSide,
  subEvento?: string,
  motivoVariazioneCittadinanza?: ItemVM<MotArtCitizenship>
): RegistrationCitizenshipFormVM => {
  const editDataControl = transformerEditDataControl(modelEventoDTO, subEvento);
  const newCitizenship = transformerNewCitizenship(
    modelEventoDTO,
    datiAggiuntiviSide,
    subEvento,
    motivoVariazioneCittadinanza
  );

  return {
    editDataControl,
    newCitizenship,
  };
};
